namespace PaperTrail.NewsletterControl {
    export interface ImageUploadRequest extends Serenity.ServiceRequest {
        GUID?: string;
        DirectoryName?: string;
        NewsletterId?: number;
        StoryId?: number;
        FileId?: number;
        FileName?: string;
        UserId?: number;
    }
}
